import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FilePicker, PickedFile } from '@capawesome/capacitor-file-picker';
import { FILE_TYPES } from '../../models/models';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploaderComponent),
      multi: true,
    },
  ],
})
export class FileUploaderComponent implements OnInit, ControlValueAccessor {
  files: PickedFile[] = [];
  @Input() extensions = [
    'pdf',
    'jpg',
    'png',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'csv',
    'zip',
  ];
  @Input() multipleSelection = true;
  @Input() isInvalid = false;
  @Output() onFilesAdded: EventEmitter<PickedFile[]> = new EventEmitter();
  types: string[] = [];
  disabled = false;

  // ControlValueAccessor implementation
  private onChange: (value: PickedFile | PickedFile[]) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {
    for (const e of this.extensions) {
      this.types.push(FILE_TYPES[e].slug);
    }
  }

  pickFiles = async () => {
    const result = await FilePicker.pickFiles({
      types: [],
      multiple: this.multipleSelection,
      readData: true,
    });
    if (this.multipleSelection) {
      const files = result.files as PickedFile[];
      this.files.push(...files);
      this.onFilesAdded.emit(files);
      this.onChange(this.files);
    } else {
      const file = result.files[0] as PickedFile;
      this.files = [file];
      this.onFilesAdded.emit([file]);
      this.onChange(file);
    }
    this.onTouched();
  };

  extensionsFormatted() {
    return this.extensions.join(', ').toUpperCase();
  }

  // ControlValueAccessor methods
  writeValue(files: PickedFile | PickedFile[]): void {
    if (!files) {
      this.files = [];
      return;
    }
    this.files = Array.isArray(files) ? files : [files];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
